import { AiTeamPage } from "@/features/ai/ai-team.page";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/",
)({
  component: AiTeamProjectPage,
});

function AiTeamProjectPage() {
  const { project } = ProjectRoute.useRouteContext();
  const projectId = project.id;

  return <AiTeamPage containerId={projectId} />;
}
